import React, { useState, useEffect } from 'react';
import { Rocket, X } from 'lucide-react';

const STORAGE_KEY = 'rk-beta-banner-dismissed';

const BetaBanner = () => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (dismissed) {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch { /* ignore */ }
    }
  }, [dismissed]);

  if (dismissed) return null;

  return (
    <div
      data-testid="beta-banner"
      className="relative bg-gradient-to-r from-indigo-600 via-blue-600 to-violet-600 text-white"
    >
      <div className="px-4 sm:px-6 py-2 flex items-center justify-center gap-2 text-xs sm:text-sm font-medium">
        <span className="inline-flex items-center gap-1.5 bg-white/20 backdrop-blur px-2 py-0.5 rounded-full text-[10px] font-bold tracking-wider flex-shrink-0">
          <Rocket size={11} />
          BETA
        </span>
        <span className="hidden sm:inline text-white/95 truncate">
          You're on the beta build — we're shipping new features at rocket speed. Got feedback? DM us.
        </span>
        <span className="sm:hidden text-white/95 truncate">
          Beta · shipping at rocket speed
        </span>
      </div>
      <button
        data-testid="beta-banner-dismiss"
        onClick={() => setDismissed(true)}
        className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-white/15 transition-colors"
        aria-label="Dismiss beta banner"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default BetaBanner;
